import { useDebouncedState as useMantineDebouncedState } from '@mantine/hooks';

export const useDebouncedState = useMantineDebouncedState;
